import React, { useState, useEffect } from 'react';
import apiClient from '../api/client';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';



function SettingsPanel() {
  const [blacklistedIPs, setBlacklistedIPs] = useState([]);
  const [newIP, setNewIP] = useState('');

  useEffect(() => {
    fetchIPs();
  }, []);

  const fetchIPs = async () => {
    const res = await apiClient.get(`/settings/blacklisted-ips`);
    setBlacklistedIPs(res.data.ips);
  };

  const addIP = async () => {
    await apiClient.post(`/settings/blacklisted-ips`, { ip: newIP });
    setNewIP('');
    fetchIPs();
  };

  const removeIP = async (ip) => {
    await apiClient.delete(`/settings/blacklisted-ips`, { data: { ip } });
    fetchIPs();
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Settings - Blacklisted IPs</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {blacklistedIPs.map(ip => (
            <div key={ip} className="flex justify-between">
              <span>{ip}</span>
              <Button variant="destructive" onClick={() => removeIP(ip)}>Remove</Button>
            </div>
          ))}
          <div className="flex space-x-2">
            <Input value={newIP} onChange={(e) => setNewIP(e.target.value)} placeholder="Enter IP" />
            <Button onClick={addIP}>Add IP</Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default SettingsPanel;